import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { AlertBarInvalidComponent } from 'src/app/components/alert-bar-invalid/alert-bar-invalid.component';
import { AlertBarComponent } from 'src/app/components/alert-bar/alert-bar.component';



@Injectable({
  providedIn: 'root'
})
export class AlertBarService {

  constructor(private _snackBar: MatSnackBar) { }

  openAlert(message: string, type: string) {

    if (type == 'error') {

      this._snackBar.openFromComponent(AlertBarInvalidComponent, {
        duration: 5 * 1000,
        data: message

      });

    }
    else {

      this._snackBar.openFromComponent(AlertBarComponent, {
        duration: 5 * 1000,
        data: message

      });

    }


  }


}
